<template>
<a href="/index.html" :class="current" :data-scp="scp">
	<i class="icon icon-shopping"></i><span v-text="text"></span>
</a>
</template>

<script>
export default {
	props: {
		current: String
		, scp: String
		, text: {
			type: String
			, default: '购物'
		}
	}
}
</script>